import { useEffect, useRef } from "react";

const CursorGlow = () => {
  const cursorRef = useRef(null);
  const spotlightRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const spotlight = spotlightRef.current;
    if (!cursor || !spotlight || window.matchMedia("(pointer: coarse)").matches) return undefined;

    let targetX = -40;
    let targetY = -40;
    let currentX = targetX;
    let currentY = targetY;
    let frameId;
    const moveCursor = (event) => {
      targetX = event.clientX;
      targetY = event.clientY;
    };
    const animate = () => {
      currentX += (targetX - currentX) * 0.18;
      currentY += (targetY - currentY) * 0.18;
      cursor.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      spotlight.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      frameId = requestAnimationFrame(animate);
    };
    const setActive = () => cursor.classList.add("cursor-active");
    const setInactive = () => cursor.classList.remove("cursor-active");

    window.addEventListener("pointermove", moveCursor, { passive: true });
    document.addEventListener("pointerover", setActive);
    document.addEventListener("pointerout", setInactive);
    frameId = requestAnimationFrame(animate);
    return () => {
      window.removeEventListener("pointermove", moveCursor);
      document.removeEventListener("pointerover", setActive);
      document.removeEventListener("pointerout", setInactive);
      cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <>
      <span ref={spotlightRef} className="cursor-trail" aria-hidden="true" />
      <span ref={cursorRef} className="custom-cursor" aria-hidden="true" />
    </>
  );
};

export default CursorGlow;
